<template>
  <div class="vacancy-page__about-section">
    <div class="vacancy-page__about-section-inner">
      <h2 class="vacancy-page__about-section-title">{{ $tVacancy('About vacancy') }}</h2>

      <AccentNote v-if="vacancy[3].features_1 || vacancy[3].features_1_description"
                  :title="vacancy[3].features_1"
                  :text="`<p>${vacancy[3].features_1_description}</p>`"
                  class="vacancy-page__accent-note"/>
      <div v-if="vacancy[3].about"
           class="vacancy-page__element  vacancy-element" :class="{_open: isOpen(1)}">
        <div class="vacancy-element__head" @click="onToggle(1)">
          <div class="vacancy-element__ico-wrap">
            <BaseSvg name="ico-header"
                     width="3.4rem"
                     height="2.6rem"
                     class="vacancy-element__ico"/>
          </div>
          <h4 class="vacancy-element__title">
            {{ $tVacancy('Responsibilities and conditions') }}
          </h4>
          <div class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
            <BaseSvg name="ico-arrow-down"/>
          </div>
        </div>

        <div class="vacancy-element__toggle">
          <div v-html="vacancy[3].about"
               class="vacancy-element__text  text"></div>
        </div>
      </div>

      <div class="vacancy-page__element  vacancy-element" :class="{_open: isOpen(2)}">
        <div class="vacancy-element__head" @click="onToggle(2)">
          <div class="vacancy-element__ico-wrap">
            <BaseSvg name="ico-building"
                     width="3.2rem"
                     height="3.2rem"
                     style="top: -0.4rem"
                     class="vacancy-element__ico"/>
          </div>
          <h4 class="vacancy-element__title">
            {{ $tVacancy('Working place') }}
          </h4>
          <div class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
            <BaseSvg name="ico-arrow-down"/>
          </div>
        </div>

        <div class="vacancy-element__toggle">
          <VacancyCompanyLogoName :vacancy="vacancy"
                                  class="vacancy-element__item"/>
          <div v-if="vacancy[3].work_place_description"
               v-html="vacancy[3].work_place_description"
               class="vacancy-element__text  text"></div>
        </div>
      </div>

      <div v-if="$get(vacancy[1], 'schedule_additional')
              || $get(vacancy[1], 'schedule_shift_duration')
              || $get(vacancy[1], 'schedule_night_shifts')
              || $get(vacancy[1], 'schedule_overtime_shifts')"
           class="vacancy-page__element  vacancy-element" :class="{_open: isOpen(3)}">
        <div class="vacancy-element__head" @click="onToggle(3)">
          <div class="vacancy-element__ico-wrap">
            <BaseSvg name="ico-schedule"
                     width="2.8rem"
                     height="2.6rem"
                     class="vacancy-element__ico"/>
          </div>
          <h4 class="vacancy-element__title">
            {{ $tVacancy('Work schedule') }}
          </h4>
          <div class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
            <BaseSvg name="ico-arrow-down"/>
          </div>
        </div>

        <div class="vacancy-element__toggle">
          <div v-if="vacancy[1].schedule_additional"
               v-html="vacancy[1].schedule_additional"
               class="vacancy-element__text  text">
          </div>
          <div class="vacancy-element__note">
            {{ scheduleNote }}
          </div>
        </div>
      </div>

      <div v-if="vacancy[2].additional_requirements"
           class="vacancy-page__element  vacancy-element" :class="{_open: isOpen(4)}">
        <div class="vacancy-element__head" @click="onToggle(4)">
          <div class="vacancy-element__ico-wrap">
            <BaseSvg name="ico-additional-requirements"
                     width="2.8rem"
                     height="2.8rem"
                     class="vacancy-element__ico"/>
          </div>
          <h4 class="vacancy-element__title">
            {{ $tVacancy('Additional requirement') }}
          </h4>
          <div class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
            <BaseSvg name="ico-arrow-down"/>
          </div>
        </div>


        <div class="vacancy-element__toggle">
          <div v-html="vacancy[2].additional_requirements"
               class="vacancy-element__text  text"></div>
        </div>
      </div>

      <AccentNote v-if="vacancy[3].features_2 || vacancy[3].features_2_description"
                  :title="vacancy[3].features_2"
                  :text="`<p>${vacancy[3].features_2_description}</p>`"
                  class="vacancy-page__accent-note"/>

      <div v-if="hasDocuments"
           class="vacancy-page__element  vacancy-element"
           :class="{_open: isOpen(5)}">
        <div class="vacancy-element__head" @click="onToggle(5)">
          <div class="vacancy-element__ico-wrap">
            <BaseSvg name="ico-documents"
                     width="2.6rem"
                     height="3.2rem"
                     class="vacancy-element__ico"/>
          </div>
          <h4 class="vacancy-element__title">
            {{ $tVacancy('Suitable documents') }}
          </h4>
          <div class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
            <BaseSvg name="ico-arrow-down"/>
          </div>
        </div>

        <div class="vacancy-element__toggle">
          <div class="vacancy-element__text  text">
            <!--              <ul>-->
            <!--                <li v-for="doc in vacancy[2].documents_for_start"-->
            <!--                    :key="doc.id">-->
            <!--                  {{ doc.name }}-->
            <!--                </li>-->
            <!--                <li v-if="vacancy[2].documents_for_start_other"-->
            <!--                    key="other">-->
            <!--                  {{ vacancy[2].documents_for_start_other }}-->
            <!--                </li>-->
            <!--              </ul>-->

            <ul
              v-if="$get(vacancy[2].additional_required_documents, 'length') || vacancy[2].additional_required_documents_other">
              <li v-for="doc in vacancy[2].additional_required_documents"
                  :key="doc.id">
                {{ doc.name }}
              </li>
              <li v-if="vacancy[2].additional_required_documents_other"
                  key="other">
                {{ vacancy[2].additional_required_documents_other }}
              </li>
            </ul>
            <div
              v-if="vacancy[2].additional_required_documents_comment"
              v-html="vacancy[2].additional_required_documents_comment"
            ></div>
          </div>
        </div>

        <!--        <collapse-transition>-->
        <!--          <div v-if="windowSizeMixin.width > WINDOW_SIZE_SM || isOpen(5)"-->
        <!--               class="vacancy-element__toggle">-->
        <!--            <div class="vacancy-element__text  text">-->
        <!--              <ul>-->
        <!--                <li v-for="doc in vacancy[2].documents_for_start"-->
        <!--                    :key="doc.id">-->
        <!--                  {{ doc.name }}-->
        <!--                </li>-->
        <!--                <li v-if="vacancy[2].documents_for_start_other"-->
        <!--                    key="other">-->
        <!--                  {{ vacancy[2].documents_for_start_other }}-->
        <!--                </li>-->
        <!--              </ul>-->
        <!--              <ul-->
        <!--                v-if="$get(vacancy[2].additional_required_documents, 'length') || vacancy[2].additional_required_documents_other">-->
        <!--                <li v-for="doc in vacancy[2].additional_required_documents"-->
        <!--                    :key="doc.id">-->
        <!--                  {{ doc.name }}-->
        <!--                </li>-->
        <!--                <li v-if="vacancy[2].additional_required_documents_other"-->
        <!--                    key="other">-->
        <!--                  {{ vacancy[2].additional_required_documents_other }}-->
        <!--                </li>-->
        <!--              </ul>-->
        <!--              <p v-if="vacancy[2].additional_required_documents_comment">-->
        <!--                {{ vacancy[2].additional_required_documents_comment }}-->
        <!--              </p>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </collapse-transition>-->
      </div>

      <div v-if="vacancy[1].salary_additional_info"
           class="vacancy-page__element  vacancy-element" :class="{_open: isOpen(6)}">
        <div class="vacancy-element__head" @click="onToggle(6)">
          <div class="vacancy-element__ico-wrap">
            <BaseSvg name="ico-wallet-2"
                     width="2.8rem"
                     height="2.4rem"
                     style="top: 0.1rem"
                     class="vacancy-element__ico"/>
          </div>
          <h4 class="vacancy-element__title">{{ $tVacancy('Salary') }}</h4>
          <div class="vacancy-element__btn-toggle d-none d-sm-inline-flex">
            <BaseSvg name="ico-arrow-down"/>
          </div>
        </div>
        <div class="vacancy-element__toggle">
          <div v-html="vacancy[1].salary_additional_info"
               class="vacancy-element__text  text">
          </div>
        </div>
      </div>

      <AccentNote v-if="vacancy[3].features_3 || vacancy[3].features_3_description"
                  :title="vacancy[3].features_3"
                  :text="`<p>${vacancy[3].features_3_description}</p>`"
                  class="d-sm-none vacancy-page__accent-note"/>

      <ShareToMessengers
        v-if="windowSizeMixin.width > WINDOW_SIZE_SM"
        :title="$tVacancy('Send vacancy:')"
        :message="$tVacancy('messengers-text')"
        :custom-links="vacancy.share_urls"
        class="vacancy-page__share"
      >
        <template v-slot:append-list>
          <span class="cursor-pointer" @click="$emit('click:custom-share-btn')">
            <BaseSvg name="ico-link-variant" width="2rem" height="2.1rem" />
          </span>
        </template>
      </ShareToMessengers>
    </div>
  </div>
</template>

<script>
  import AccentNote from '../../components/vacancy/AccentNote'
  import VacancyCompanyLogoName from '../../components/vacancy/VacancyCompanyLogoName'
  import {WINDOW_SIZE_SM} from '@/constants/windowSizes'
  import windowSizeMixin from '@/mixins/windowSizeMixin'
  import ShareToMessengers from '@/components/ShareToMessengers'

  export default {
    name: 'VacancyAboutSection',
    mixins: [windowSizeMixin],
    components: {
      AccentNote,
      VacancyCompanyLogoName,
      ShareToMessengers
    },
    props: ['vacancy'],
    data() {
      return {
        WINDOW_SIZE_SM,
        toggleSections: []
      }
    },
    computed: {
      hasDocuments() {
        return this.$get(this.vacancy[2].additional_required_documents, 'length')
          || this.$get(this.vacancy[2], 'additional_required_documents_comment')
        // this.$get(this.vacancy[2].documents_for_start, 'length')
        // || this.$get(this.vacancy[2], 'documents_for_start_other')
        // || this.$get(this.vacancy[2].additional_required_documents, 'length')
        // || this.$get(this.vacancy[2], 'additional_required_documents_comment')
      },
      scheduleNote() {
        const vacancySection = this.vacancy[1]
        const result = []

        if (Array.isArray(vacancySection.schedule_shift_duration)) {
          vacancySection.schedule_shift_duration.forEach(item => {
            result.push(
              `${this.$tVacancy('Shifts by')} ${item.name}`
            )
          })
        }

        if (typeof vacancySection.schedule_night_shifts === 'boolean') {
          result.push(
            vacancySection.schedule_night_shifts
              ? this.$tVacancy('Night shifts')
              : this.$tVacancy('No night shifts')
          )
        }

        if (typeof vacancySection.schedule_overtime_shifts === 'boolean') {
          result.push(
            vacancySection.schedule_overtime_shifts
              ? this.$tVacancy('Ability to work overtime')
              : this.$tVacancy('Without the ability to work overtime')
          )
        }

        return result.join(' • ')
      }
    },
    methods: {
      isOpen(id) {
        return this.toggleSections.some(item => item === id)
      },
      onToggle(id) {
        if (window.innerWidth > WINDOW_SIZE_SM) return
        if (this.isOpen(id)) {
          this.toggleSections = this.toggleSections.filter(item => item !== id)
        } else {
          this.toggleSections.push(id)
        }
      }
    }
  }
</script>

<style lang="less">

</style>
